import { Component, DestroyRef, inject, input, OnInit, PLATFORM_ID, Renderer2, signal } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { JobDetailService } from '../../services/job-details.service';
import { ActivatedRoute } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { CookieService } from '../../../../core/services/cookie/cookie.service';
import { Cookies, SharedItem } from '../../../../shared/enums/app.enums';
import { ReportFormModel } from '../../models/details.model';
import { isPlatformBrowser } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReportTypes } from '../../utils/details.const';
import { ReportJobModal } from '../../modals/report-job-modal/report-job-modal';

@Component({
  selector: 'app-report-job-company',
  standalone: true,
  imports: [TranslocoModule, ReportJobModal],
  templateUrl: './report-job-company.html',
  styleUrl: './report-job-company.scss'
})
export class ReportJobCompany implements OnInit {
  private renderer = inject(Renderer2)
  private jobdetailsService = inject(JobDetailService);
  private cookieService = inject(CookieService)
  private route = inject(ActivatedRoute);
  private destroyRef = inject(DestroyRef)
  private platformId = inject(PLATFORM_ID)

  private isBrowser!:boolean
  
  JobId:string | null = null;
  readonly jobAppliedEmail = input('')
  readonly c2c = input('0')
  isReportSubmitted:boolean = false;
  isReportModalOpen:boolean = false;
  report_this_job = signal<string>('');
  

  readonly formValue = this.cookieService.getCookie(Cookies.MyBDJOBSUSERID)?.trim() ?? '';
  readonly isLoggedIn = this.formValue.length > 0;
  deviceType:string=SharedItem.DEVICE;
  encoded:string =SharedItem.ENCODED;
  Alias_Status:number =SharedItem.ALIAS_STATUS;

  reportTypes = ReportTypes
  screenWidth = 0

  ReportForm = new FormGroup({
    email:new FormControl<string | null>(''),
    ReportType: new FormControl<string>('',Validators.required),
    Comments: new FormControl<string | null>('',Validators.maxLength(500)),
  })

  ngOnInit(): void {
    this.isBrowser = isPlatformBrowser(this.platformId)
    if(this.isBrowser){
      this.screenWidth = window.innerWidth;
      window.addEventListener('resize', () => {
        this.screenWidth = window.innerWidth;
      });
      this.route.paramMap
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((params) => {
          this.JobId = params.get('id'); 
      });
    }    

      this.setEmailValidation();
  }
  setEmailValidation(): void {
    const emailControl = this.ReportForm.get('email');
    if (!this.isLoggedIn) {
      this.ReportForm.get('email')?.setValidators([Validators.required]);
    } else {
      this.ReportForm.get('email')?.clearValidators();
      this.ReportForm.get('email')?.updateValueAndValidity();
    }
    emailControl?.updateValueAndValidity();
  }

  

  openReportModal(){
    this.isReportModalOpen = true;
    if(this.isBrowser){
      this.renderer.addClass(document.body, 'overflow-hidden');
    }
    
  }

  closeReportModal(){
    this.isReportModalOpen = false;
    this.ReportForm.reset({
      ReportType: ''
    });
    if(this.isBrowser){
      this.renderer.addClass(document.body, 'overflow-auto');
      this.renderer.removeClass(document.body, 'overflow-hidden');
    }
    
  }

  closeSubmitReport(){
    this.isReportSubmitted = false;
    this.ReportForm.reset({
      ReportType: ''
    });
    if(this.isBrowser){
      this.renderer.removeClass(document.body, 'overflow-hidden');
    }
    
  }

  onSubmit(){
    if(this.ReportForm.invalid){
      this.ReportForm.markAllAsTouched();
      return;
    }

    const body: ReportFormModel = {
      ReportType:this.ReportForm.get('ReportType')?.value ?? '',
      Comments:this.ReportForm.get('Comments')?.value ?? '',
      deviceType:this.deviceType,
      formValue:this.formValue,
      JobId:this.JobId || '',
      JobAppliedEmail:this.ReportForm.get('email')?.value ?? '',
      IPAddress: "",
      BrowserInfo: "",
    }
    this.isReportModalOpen = false;
    this.isReportSubmitted = true;
    this.jobdetailsService.postReportForm(body)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
      next:(response) =>{},
      error:(err) =>{}
    })
    
  }
}
